import { RhCard, RhChip } from "@rhythm-ui/react";
import React from "react";

import { JobType } from "@/types/job";
import { SkillType } from "@/types/utils";

const JobDetailsTab = ({ jobDetail }: { jobDetail: JobType }) => {
  return (
    <>
      <JobDescriptionCard jobDetail={jobDetail} />
      <RhCard className="my-tsm overflow-visible p-tm2">
        <JobSkillsDisplay jobDetail={jobDetail} />
      </RhCard>
      <ClientDetailsCard jobDetail={jobDetail} />
    </>
  );
};

export default JobDetailsTab;

const JobSkillsDisplay = ({ jobDetail }: { jobDetail: JobType }) => {
  return (
    <div className="flex flex-col gap-tm2">
      <div className="flex justify-between">
        <div className="flex flex-col gap-tpico">
          <p className="text-hint">Job Role</p>
          <p>{jobDetail?.job_role?.name || "-"}</p>
        </div>
      </div>

      <div className="flex flex-col gap-tpico">
        <p className="text-hint">Primary Skills</p>

        <div className="flex flex-wrap gap-tnano">
          {jobDetail.primary_skills?.map(
            (skills_details: SkillType, idx: number) => {
              return <RhChip key={idx}>{skills_details.name}</RhChip>;
            },
          )}
          {!jobDetail.primary_skills?.length && <span>-</span>}
        </div>
      </div>

      <div className="flex flex-col gap-tpico">
        <p className="text-hint">Secondary Skills</p>
        <div className="flex flex-wrap gap-tnano">
          {jobDetail.other_skills?.map(
            (skills_details: SkillType, idx: number) => {
              return <RhChip key={idx}>{skills_details.name}</RhChip>;
            },
          )}
        </div>

        {!jobDetail.other_skills?.length && <span>-</span>}
      </div>
    </div>
  );
};

const ClientDetailsCard = ({ jobDetail }: { jobDetail: JobType }) => {
  return (
    <RhCard className="my-tsm grid grid-cols-1 gap-tm2 p-tm2 lg:grid-cols-2">
      <div className="flex flex-col gap-tpico">
        <p className="text-hint">Headquartered In</p>
        <p>{jobDetail?.company?.hq_location?.name || "-"}</p>
      </div>

      <div className="flex flex-col gap-tpico">
        <p className="text-hint">Industry Type</p>
        <div className="flex">
          {jobDetail?.company?.industry_detail.map((it, index) => (
            <p key={index}>
              {it.name || "-"}
              {index < jobDetail.company.industry_detail.length - 1
                ? ", \u00A0"
                : ""}
            </p>
          ))}
        </div>
      </div>

      <div className="flex flex-col gap-tpico">
        <p className="text-hint">Company Size</p>
        <p>{jobDetail?.company?.size?.name || "-"}</p>
      </div>

      <div className="flex flex-col gap-tpico">
        <p className="text-hint">Company Stage</p>
        <p>{jobDetail?.company?.stage?.name || "-"}</p>
      </div>
    </RhCard>
  );
};

const JobDescriptionCard = ({ jobDetail }: { jobDetail: JobType }) => {
  return (
    <RhCard className="my-tsm overflow-visible p-tm2">
      <div className="flex items-center justify-between">
        <h4>Roles & Responsibilities</h4>
      </div>
      <div className="pt-tm2">
        {!jobDetail.job_description || jobDetail.job_description === "" ? (
          "-"
        ) : (
          <div
            dangerouslySetInnerHTML={{ __html: jobDetail.job_description }}
          />
        )}
      </div>
    </RhCard>
  );
};
